<template>
  <v-container
    pa-0
    mb-5
  >
    <v-row>
      <v-col
        v-for="(type, i) in types"
        :key="i"
        cols="12"
        sm="6"
        md="4"
      >
        <v-hover close-delay="20">
          <template v-slot="{ hover }">
            <v-card
              :elevation="hover ? 2 : 8"
              hover
            >
              <div class="pa-3">
                <v-img
                  :aspect-ratio="1/1"
                  :src="type.img"
                  contain
                />
              </div>

              <v-fade-transition>
                <v-overlay
                  v-if="hover"
                  absolute
                  class="text-xs-right"
                  color="rgba(44, 122, 144, .55)"
                >
                  <v-slide-x-transition appear>
                    <v-btn
                      class="subheading font-weight-light text-capitalize mx-0 mt-3"
                      color="secondary"
                      depressed
                      large
                    >
                      View Classes
                    </v-btn>
                  </v-slide-x-transition>
                </v-overlay>
              </v-fade-transition>
              <div class="pa-3 primary text-xs-center white--text">
                {{ type.name }}
              </div>
            </v-card>
          </template>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      types: [
        {
          name: 'Stretch Classes (20 mins)',
          img: require('@/assets/class-types/stretch.png')
        },
        {
          name: 'Full Classes (40 - 75 mins)',
          img: require('@/assets/class-types/all-level-ballet-class.png')
        },
        {
          name: 'Pointe (25-45 mins)',
          img: require('@/assets/class-types/int-pointe.png')
        }
      ]
    })
  }
</script>
